import styled from 'styled-components';
import OTPInput from 'otp-input-react';

export const Label = styled.label`
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 10px;
  color: #4d4d4d;
`;

export const Input = styled(OTPInput)`
  display: grid;
  gap: 7px;
  grid-template-columns: repeat(6, auto);
  justify-content: space-between;
  margin-bottom: 8px;
`;

interface HelperTextProps {
  $error: boolean;
}

export const HelperText = styled.p<HelperTextProps>`
  display: inline-block;
  font-size: 12px;
  letter-spacing: 0em;
  text-align: left;
  color: ${(props) => (props.$error ? '#f44336' : '#4d4d4d')};
`;

export const InputArea = styled.div`
  display: block;
  margin-bottom: 8px;
`;
